import { FC, ReactNode, useCallback } from 'react';
import { Link } from 'react-router';
import { RouterConfig } from '@edikk-edikk/country-frontend';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import Location2Svg from '#srcIcons/location-2.svg';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import modelDetailContactListCss from '../assets/model-detail/model-detail-contact-list.module.scss';
import { useBaseContext } from '#base/hooks';

const Location: FC = () => {
  const {
    advert: {
      city,
    },
  } = useAdvertDetailContext();
  const { isSingleCity } = useBaseContext();

  const wrapLink = useCallback((node: ReactNode): ReactNode => {
    if (city.url) {
      return (
        <Link
          to={city.url}
          state={{ routerConfig: RouterConfig.initForCity(city.id) }}
          className={modelDetailContactListCss.modelDetailContactList__item}
        >
          {node}
        </Link>
      );
    }

    return (
      <div className={modelDetailContactListCss.modelDetailContactList__item}>
        {node}
      </div>
    );
  }, [city.id, city.url]);

  if (isSingleCity) {
    return null;
  }

  return wrapLink((
    <>
      <SvgIcon Component={Location2Svg} size="1em" isWithoutStroke />
      {city.title}
    </>
  ));
};

export { Location };
